import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AmountDueBreakdown = styled.div`
  margin-top: ${Spacing.S8};
  padding-top: ${Spacing.S8};
  border-top: 1px solid ${Color.Grey500};

  /* The amount-due row draws its own line. This block owns the one above the breakdown. */
  && > :last-child {
    padding-top: 0;
    border-top: none;
  }
`
